export default "__VITE_ASSET__BQNF9a9i__"